import { render, staticRenderFns } from "./SeletorDeCliente.vue?vue&type=template&id=9dcc0a34&scoped=true&"
import script from "./SeletorDeCliente.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeCliente.vue?vue&type=script&lang=ts&"
import style0 from "./SeletorDeCliente.vue?vue&type=style&index=0&id=9dcc0a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcc0a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCombobox,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
